import { useState, useEffect } from "react";
import DSBox from "../../views/system-design/DSBox";
import DSSwitch from "../../views/system-design/DSSwitch";
import DSTypography from "../../views/system-design/DSTypography";

const SimpleSwitch = (props: {
  title: string;
  default: boolean;
  onClick: (on: boolean) => void;
  on: string[] | undefined;
  disabled?: boolean;
}) => {
  const [on, setOn] = useState(props.default);

  useEffect(() => {
    setOn(props.default);
  }, [props.default]);
  const s = props.on ? props.on : [" on", " off"];
  const isDisabled = props.disabled ?? false;
  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        opacity: isDisabled ? 0.5 : 1,
      }}
    >
      <DSSwitch
        checked={on}
        disabled={isDisabled}
        onChange={() => {
          if (!isDisabled) {
            props.onClick(!on);
            setOn(!on);
          }
        }}
      />
      <DSTypography
        onClick={() => {
          if (!isDisabled) {
            props.onClick(!on);
            setOn(!on);
          }
        }}
        sx={{
          cursor: isDisabled ? "not-allowed" : "pointer",
          fontWeight: 700,
        }}
      >
        {String(props.title + (on ? s[0] : s[1]))}
      </DSTypography>
    </DSBox>
  );
};

export default SimpleSwitch;
